module.exports = __webpack_public_path__ + "static/media/scaleW-icon.e18a9aea.svg";